<template>
  <v-container fluid>
    <v-card>
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Comissões</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="primary lighten-4"
          @click="$router.push('comissoes/adicionar')"
          class="hidden-xs-only ml-2"
          >Adicionar</v-btn
        >
        <v-btn
          fab
          small
          color="primary lighten-4"
          @click="$router.push('comissoes/adicionar')"
          class="hidden-sm-and-up ml-2"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-app-bar>

      <v-expand-transition>
        <v-row dense v-show="exibirPesquisa" class="pa-2">
          <v-col cols="12" pa-2>
            <v-text-field
              ref="pesquisa"
              label="Pesquisa"
              v-model="pesquisa"
              prepend-inner-icon="search"
              solo
              clearable
              single-line
              hide-details
              placeholder="Pesquisa"
              dark
              background-color="primary lighten-2"
              @click:clear="tooglePesquisa"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-expand-transition>

      <v-data-table
        :search="pesquisa"
        :headers="headers"
        :items="recebimentos"
        :loading="loading"
        no-data-text="Sem registros"
        no-results-text="Sem registros"
        loading-text="Carregando dados..."
        :items-per-page="30"
        :footer-props="{
          itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }],
          itemsPerPageText: '',
        }"
      >
        <template v-slot:item.data="{ item }">{{
          item.data | dataBR
        }}</template>
        <template v-slot:item.valor_total="{ item }">{{
          item.valor_total | valorBR
        }}</template>
        <template v-slot:item.acoes="{ item }">
          <div style="display: flex; justify-content: center;">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  @click="$router.push('comissoes/' + item.id + '/editar')"
                >
                  <v-list-item-title>
                    <v-icon class="pr-4">edit</v-icon>Editar
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="abrirDialogoExcluir(item)">
                  <v-list-item-title>
                    <v-icon class="pr-4">mdi-delete</v-icon>Excluir
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <as-dialogo
      ref="dialogoExcluir"
      title="Excluir Recebimento"
      max-width="440px"
      hideCloseButton
    >
      <v-label>Tem certeza que deseja excluir esse recebimento?</v-label>
      <div class="pt-4" style="display: flex; justify-content: flex-end;">
        <v-btn
          depressed
          class="mr-4"
          @click="$refs.dialogoExcluir.fechar()"
          :disabled="excluindo"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="error"
          @click="excluir"
          :disabled="excluindo"
          :loading="excluindo"
          >Excluir</v-btn
        >
      </div>
    </as-dialogo>
  </v-container>
</template>

<script>
import ServiceRecebimentos from "@/services/recebimentos.js";
export default {
  name: "ComissoesLista",
  data() {
    return {
      loading: false,
      user: {},
      recebimentos: [],
      recebimento: {},
      exibirPesquisa: false,
      pesquisa: "",
      headers: [
        { text: "Número", value: "id", width: "5%" },
        { text: "Data", value: "data", width: "10%" },
        { text: "Cliente", value: "cliente_nome", width: "35%" },
        { text: "Forma de Pagamento", value: "forma_pagamento", width: "25%" },
        { text: "Pedidos", value: "pedidos_quantidade", width: "10%" },
        { text: "Valor", value: "valor_total", width: "10%" },
        { text: "", value: "acoes", width: "5%" },
      ],
      excluindo: false,
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.listar();
  },
  methods: {
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    async listar() {
      try {
        this.loading = true;
        let recebimentos_response = await ServiceRecebimentos.listar();
        this.recebimentos = recebimentos_response.data.recebimentos;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro(error.response.data.msg);
      } finally {
        this.loading = false;
      }
    },
    abrirDialogoExcluir(recebimento_selecionado) {
      this.recebimento = this.clone(recebimento_selecionado);
      this.$refs.dialogoExcluir.abrir();
    },
    async excluir() {
      try {
        this.excluindo = true;
        await ServiceRecebimentos.excluir(this.recebimento.id);
        this.recebimento = {};
        this.$eventbus.notificar("Recebimento excluído com sucesso");
        this.listar();
        this.$refs.dialogoExcluir.fechar();
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao excluir recebimento");
      } finally {
        this.excluindo = false;
      }
    },
  },
};
</script>

<style></style>
